




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_PATH } from "../Constant/constants";

// const AppointmentList = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editingAppointment, setEditingAppointment] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const token = localStorage.getItem("authToken");

//   const fetchAppointments = async () => {
//     try {
//       const res = await axios.get(`${API_PATH}/appointments`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setAppointments(res.data);
//     } catch (err) {
//       console.error("Fetch error:", err);
//       alert("Error fetching appointments.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAppointments();
//   }, []);


//   const filteredAppointments = appointments.filter((appointment) =>
//     `${appointment.patientFirstName} ${appointment.patientLastName}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase()) ||
//     appointment.patientEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     appointment.reason.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this appointment?")) return;
//     try {
//       await axios.delete(`${API_PATH}/appointments/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       alert("Appointment deleted successfully!");
//       fetchAppointments();
//     } catch (err) {
//       console.error("Delete error:", err);
//       alert("Error deleting appointment.");
//     }
//   };

//   const handleEdit = (appointment) => {
//     setEditingAppointment({ ...appointment });
//   };

//   const handleEditChange = (e) => {
//     const { name, value } = e.target;
//     setEditingAppointment((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleUpdate = async () => {
//     try {
//       await axios.patch(`${API_PATH}/appointments/${editingAppointment.id}`, editingAppointment, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       });
//       alert("Appointment updated successfully!");
//       setEditingAppointment(null);
//       fetchAppointments();
//     } catch (err) {
//       console.error("Update error:", err);
//       alert("Error updating appointment.");
//     }
//   };

//   return (
//     <div className="bg-light shadow rounded  mt-5 ">
//       <h4>className="text-center mb-3">Appointment List</h4>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Search by patient name, email, or reason"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)} // Update search term
//         />
//       </div>

//       {editingAppointment && (
//         <div className="mb-4 p-3 border rounded bg-white">
//           <h5>Edit Appointment</h5>
//           <div className="row g-3">
//             {[
//               { label: "ID", name: "id", type: "number" },
//               { label: "Slot ID", name: "slotId", type: "number" },
//               { label: "Doctor ID", name: "doctorId", type: "number" },
//               { label: "First Name", name: "patientFirstName" },
//               { label: "Last Name", name: "patientLastName" },
//               { label: "Email", name: "patientEmail" },
//               { label: "Phone Number", name: "patientNumber" },
//               { label: "Address", name: "patientAddress" },
//               { label: "Appointment Date", name: "appointmentDate", type: "date" },
//               { label: "Start Time", name: "startTime", type: "time" },
//               { label: "End Time", name: "endTime", type: "time" },
//               { label: "Reason", name: "reason" },
//               { label: "Status", name: "status" },
//               { label: "Appointment Type", name: "appointmentType" },
//               { label: "Priority", name: "priority" },
//             ].map((field) => (
//               <div className="col-md-4" key={field.name}>
//                 <label>{field.label}</label>
//                 <input
//                   name={field.name}
//                   value={editingAppointment[field.name]}
//                   type={field.type || "text"}
//                   className="form-control"
//                   onChange={handleEditChange}
//                 />
//               </div>
//             ))}
//             <div className="col-12 d-flex justify-content-between">
//               <button onClick={handleUpdate} className="btn btn-success">Update</button>
//               <button onClick={() => setEditingAppointment(null)} className="btn btn-secondary">Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <div className="table-responsive w-100 overflow-scroll">
//           <table className="table table-bordered table-striped ">
//             <thead className="table-dark">
//               <tr>
//                 <th>#</th>
//                 <th>Patient Info</th>
//                 <th>Email</th>
//                 <th>Doctor ID</th>
//                 <th>Slot ID</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Contact</th>
//                 <th>Address</th>
//                 <th>Reason</th>
//                 <th>Status</th>
//                 <th>Type</th>
//                 <th>Priority</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {appointments.length > 0 ? (
//                 appointments.map((app, index) => (
//                   <tr key={app.id}>
//                     <td>{index + 1}</td>
//                     <td>
//                       {app.patientFirstName} {app.patientLastName}
                     
//                     </td>
//                     <td>{app.patientEmail}</td>
//                     <td>{app.doctorId}</td>
//                     <td>{app.slotId}</td>
//                     <td>{app.appointmentDate}</td>
//                     <td>{app.startTime} - {app.endTime}</td>
//                     <td>{app.patientNumber}</td>
//                     <td>{app.patientAddress}</td>
//                     <td>{app.reason}</td>
//                     <td>{app.status}</td>
//                     <td>{app.appointmentType}</td>
//                     <td>{app.priority}</td>
//                     <td>
//                       <button className="btn btn-sm btn-warning me-2 px-2 py-2" onClick={() => handleEdit(app)}>Edit</button>
//                       <button className="btn btn-sm btn-danger px-2 py-2" onClick={() => handleDelete(app.id)}>Delete</button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="13" className="text-center">No appointments found.</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AppointmentList;





// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { API_PATH } from "../Constant/constants";

// const AppointmentList = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [editingAppointment, setEditingAppointment] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");
//   const token = localStorage.getItem("authToken");

//   const [emailFilter, setEmailFilter] = useState(""); // New state for email filter
//   const [mobileFilter, setMobileFilter] = useState("");

//   const fetchAppointments = async () => {
//     if (!token) {
//       alert("Authentication token is missing. Please log in again.");
//       return;
//     }
//     try {
//       const res = await axios.get(`${API_PATH}/appointments`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setAppointments(res.data);
//     } catch (err) {
//       console.error("Error fetching appointments:", err);
//       alert("Failed to fetch appointments. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAppointments();
//   }, []);

//   const filteredAppointments = appointments.filter((appointment) => {
//     const fullName = `${appointment.patientFirstName} ${appointment.patientLastName}`.toLowerCase();
//     const email = appointment.patientEmail.toLowerCase();
//     const mobile = appointment.patientNumber.toLowerCase();
//     const reason = appointment.reason.toLowerCase();

//     return (
//       (searchTerm && (fullName.includes(searchTerm.toLowerCase()) || reason.includes(searchTerm.toLowerCase()))) ||
//       (emailFilter && email.includes(emailFilter.toLowerCase())) ||
//       (mobileFilter && mobile.includes(mobileFilter.toLowerCase()))
//     );
//   });


//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this appointment?")) return;
//     try {
//       await axios.delete(`${API_PATH}/appointments/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       alert("Appointment deleted successfully!");
//       fetchAppointments();
//     } catch (err) {
//       console.error("Error deleting appointment:", err);
//       alert("Failed to delete the appointment. Please try again.");
//     }
//   };

//   const handleEdit = (appointment) => {
//     setEditingAppointment({ ...appointment });
//   };

//   const handleEditChange = (e) => {
//     const { name, value } = e.target;
//     setEditingAppointment((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleUpdate = async () => {
//     if (!editingAppointment) return;
//     try {
//       await axios.patch(
//         `${API_PATH}/appointments/${editingAppointment.id}`,
//         editingAppointment,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       alert("Appointment updated successfully!");
//       setEditingAppointment(null);
//       fetchAppointments();
//     } catch (err) {
//       console.error("Error updating appointment:", err);
//       alert("Failed to update the appointment. Please try again.");
//     }
//   };

//   return (
//     <div className="bg-light shadow rounded mt-5">
//       <h4>className="text-center mb-3">Appointment List</h4>

//       <div className="mb-3">
//         <input
//           type="text"
//           className="form-control mb-2"
//           placeholder="Search by patient name or reason"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <input
//           type="text"
//           className="form-control mb-2"
//           placeholder="Filter by email"
//           value={emailFilter}
//           onChange={(e) => setEmailFilter(e.target.value)}
//         />
//         <input
//           type="text"
//           className="form-control"
//           placeholder="Filter by mobile number"
//           value={mobileFilter}
//           onChange={(e) => setMobileFilter(e.target.value)}
//         />
//       </div>

//       {editingAppointment && (
//         <div className="mb-4 p-3 border rounded bg-white">
//           <h5>Edit Appointment</h5>
//           <div className="row g-3">
//             {[
//               { label: "ID", name: "id", type: "number" },
//               { label: "Slot ID", name: "slotId", type: "number" },
//               { label: "Doctor ID", name: "doctorId", type: "number" },
//               { label: "First Name", name: "patientFirstName" },
//               { label: "Last Name", name: "patientLastName" },
//               { label: "Email", name: "patientEmail" },
//               { label: "Phone Number", name: "patientNumber" },
//               { label: "Address", name: "patientAddress" },
//               { label: "Appointment Date", name: "appointmentDate", type: "date" },
//               { label: "Start Time", name: "startTime", type: "time" },
//               { label: "End Time", name: "endTime", type: "time" },
//               { label: "Reason", name: "reason" },
//               { label: "Status", name: "status" },
//               { label: "Appointment Type", name: "appointmentType" },
//               { label: "Priority", name: "priority" },
//             ].map((field) => (
//               <div className="col-md-4" key={field.name}>
//                 <label>{field.label}</label>
//                 <input
//                   name={field.name}
//                   value={editingAppointment[field.name] || ""}
//                   type={field.type || "text"}
//                   className="form-control"
//                   onChange={handleEditChange}
//                 />
//               </div>
//             ))}
//             <div className="col-12 d-flex justify-content-between">
//               <button onClick={handleUpdate} className="btn btn-success">
//                 Update
//               </button>
//               <button
//                 onClick={() => setEditingAppointment(null)}
//                 className="btn btn-secondary"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {loading ? (
//         <p>Loading...</p>
//       ) : (
//         <div className="table-responsive w-100 overflow-scroll">
//           <table className="table table-bordered table-striped">
//             <thead className="table-dark">
//               <tr>
//                 <th>#</th>
//                 <th>Patient Info</th>
//                 <th>Email</th>
//                 <th>Doctor ID</th>
//                 <th>Slot ID</th>
//                 <th>Date</th>
//                 <th>Time</th>
//                 <th>Contact</th>
//                 <th>Address</th>
//                 <th>Reason</th>
//                 <th>Status</th>
//                 <th>Type</th>
//                 <th>Priority</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {appointments.length > 0 ? (
//                 filteredAppointments.map((app, index) => (
//                   <tr key={app.id}>
//                     <td>{index + 1}</td>
//                     <td>
//                       {app.patientFirstName} {app.patientLastName}
//                     </td>
//                     <td>{app.patientEmail}</td>
//                     <td>{app.doctorId}</td>
//                     <td>{app.slotId}</td>
//                     <td>{app.appointmentDate}</td>
//                     <td>
//                       {app.startTime} - {app.endTime}
//                     </td>
//                     <td>{app.patientNumber}</td>
//                     <td>{app.patientAddress}</td>
//                     <td>{app.reason}</td>
//                     <td>{app.status}</td>
//                     <td>{app.appointmentType}</td>
//                     <td>{app.priority}</td>
//                     <td>
//                       <button
//                         className="btn btn-sm btn-warning me-2 px-2 py-2"
//                         onClick={() => handleEdit(app)}
//                         aria-label={`Edit appointment for ${app.patientFirstName} ${app.patientLastName}`}
//                       >
//                         Edit
//                       </button>
//                       <button
//                         className="btn btn-sm btn-danger px-2 py-2"
//                         onClick={() => handleDelete(app.id)}
//                         aria-label={`Delete appointment for ${app.patientFirstName} ${app.patientLastName}`}
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="13" className="text-center">
//                     No appointments found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AppointmentList;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_PATH } from "../Constant/constants";

const AppointmentList = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingAppointment, setEditingAppointment] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  const [mobileFilter, setMobileFilter] = useState("");
  const token = localStorage.getItem("authToken");

  const fetchAppointments = async () => {
    if (!token) {
      alert("Authentication token is missing. Please log in again.");
      return;
    }
    try {
      const res = await axios.get(`${API_PATH}/appointments`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (Array.isArray(res.data)) {
        setAppointments(res.data);
      } else {
        console.error("Unexpected response format:", res.data);
        alert("Failed to fetch appointments. Please try again later.");
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
      alert("Failed to fetch appointments. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, []);

  const filteredAppointments = appointments.filter((appointment) => {
    const fullName = `${appointment.patientFirstName} ${appointment.patientLastName}`.toLowerCase();
    const email = appointment.patientEmail.toLowerCase();
    const mobile = appointment.patientNumber.toLowerCase();
    const reason = appointment.reason.toLowerCase();

    return (
      (!searchTerm || fullName.includes(searchTerm.toLowerCase()) || reason.includes(searchTerm.toLowerCase())) &&
      (!emailFilter || email.includes(emailFilter.toLowerCase())) &&
      (!mobileFilter || mobile.includes(mobileFilter.toLowerCase()))
    );
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this appointment?")) return;
    try {
      await axios.delete(`${API_PATH}/appointments/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Appointment deleted successfully!");
      fetchAppointments();
    } catch (err) {
      console.error("Error deleting appointment:", err);
      alert("Failed to delete the appointment. Please try again.");
    }
  };

  const handleEdit = (appointment) => {
    setEditingAppointment({ ...appointment });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditingAppointment((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    if (!editingAppointment) return;
    try {
      await axios.patch(
        `${API_PATH}/appointments/${editingAppointment.id}`,
        editingAppointment,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      alert("Appointment updated successfully!");
      setEditingAppointment(null);
      fetchAppointments();
    } catch (err) {
      console.error("Error updating appointment:", err);
      alert("Failed to update the appointment. Please try again.");
    }
  };

  return (
    <div className="row appointment-table px-2 py-2" style={{ width: "1250px" }}>
    <div className="bg-light shadow rounded  " >
      <h4 className="text-center mb-3">Appointment List</h4>

  

     
     <div className="mb-3">
        <div className="d-flex gap-2 flex-nowrap">
          <input
            type="text"
            className="form-control flex-fill"
            style={{ minWidth: 0 }}
            placeholder="Search by patient name or reason"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <input
            type="text"
            className="form-control flex-fill"
            style={{ minWidth: 0 }}
            placeholder="Filter by email"
            value={emailFilter}
            onChange={(e) => setEmailFilter(e.target.value)}
          />
          <input
            type="text"
            className="form-control flex-fill"
            style={{ minWidth: 0 }}
            placeholder="Filter by mobile number"
            value={mobileFilter}
            onChange={(e) => setMobileFilter(e.target.value)}
          />
        </div>
      </div>



      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className="table-responsive  w-100 mw-100 px-2 py-2">
          <div style={{ maxHeight: "400px", overflowX:"scroll" }}>
          <table className=" table-bordered ">
            <thead className="tableborder">
              <tr>
                <th>#</th>
                <th>Patient Info</th>
                <th>Email</th>
                <th>Doctor ID</th>
                <th>Slot ID</th>
                <th>Date</th>
                <th>Time</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Reason</th>
                <th>Status</th>
                <th>Type</th>
                <th>Priority</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAppointments.length > 0 ? (
                filteredAppointments.map((app, index) => (
                  <tr key={app.id} className="datahover">
                    <td>{index + 1}</td>
                    <td>
                      {app.patientFirstName} {app.patientLastName}
                    </td>
                    <td>{app.patientEmail}</td>
                    <td>{app.doctorId}</td>
                    <td>{app.slotId}</td>
                    <td>{app.appointmentDate}</td>
                    <td>
                      {app.startTime} - {app.endTime}
                    </td>
                    <td>{app.patientNumber}</td>
                    <td>{app.patientAddress}</td>
                    <td>{app.reason}</td>
                    <td>{app.status}</td>
                    <td>{app.appointmentType}</td>
                    <td>{app.priority}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning  px-2 py-2"
                        onClick={() => handleEdit(app)}
                        aria-label={`Edit appointment for ${app.patientFirstName} ${app.patientLastName}`}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger px-2 py-2 ms-2"
                        onClick={() => handleDelete(app.id)}
                        aria-label={`Delete appointment for ${app.patientFirstName} ${app.patientLastName}`}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center">
                    No appointments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>
      )}

      
      {editingAppointment && (
        <div className="mb-4 p-3 border rounded bg-white">
          <h5>Edit Appointment</h5>
          <div className="row g-3">
            {[
              { label: "ID", name: "id", type: "number" , disabled: true  },
              { label: "Slot ID", name: "slotId", type: "number" },
              { label: "Doctor ID", name: "doctorId", type: "number" },
              { label: "First Name", name: "patientFirstName" },
              { label: "Last Name", name: "patientLastName" },
              { label: "Email", name: "patientEmail" },
              { label: "Phone Number", name: "patientNumber" },
              { label: "Address", name: "patientAddress" },
              { label: "Appointment Date", name: "appointmentDate", type: "date" },
              { label: "Start Time", name: "startTime", type: "time" },
              { label: "End Time", name: "endTime", type: "time" },
              { label: "Reason", name: "reason" },
              { label: "Status", name: "status" },
              { label: "Appointment Type", name: "appointmentType" },
              { label: "Priority", name: "priority" },
            ].map((field) => (
              <div className="col-md-4" key={field.name}>
                <label>{field.label}</label>
                <input
                  name={field.name}
                  value={editingAppointment[field.name] || ""}
                  type={field.type || "text"}
                  className="form-control"
                  onChange={handleEditChange}
                />
              </div>
            ))}
            <div className="col-12 d-flex justify-content-between">
              <button onClick={handleUpdate} className="btn btn-success">
                Update
              </button>
              <button
                onClick={() => setEditingAppointment(null)}
                className="btn btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}</div>

    </div>
  
  );
};

export default AppointmentList;